import { supabase } from '../lib/supabase';
import { UserRole, TeamRole } from '../types/saas';
import logger from '../utils/logger';

export interface UserProfile {
  id: string; // UUID from Supabase
  phone_number: string;
  email?: string;
  first_name: string;
  last_name: string;
  role: UserRole | string;
  team_id?: string;
  team_role: TeamRole | string;
  desktop_code?: string;
  is_active: boolean;
  created_at: string;
}

export const userService = {
  // Kullanıcı profilini al
  getUserProfile: async (id: string): Promise<UserProfile | null> => {
    try {
      const { data, error } = await supabase
        .from('user_profiles')
        .select('*')
        .eq('id', id)
        .maybeSingle();

      if (error) {
        // 406 (RLS), PGRST116 (no rows) → null döndür, throw etme
        logger.error('Profil okuma hatası (null döndürülüyor):', error.code, error.message);
        return null;
      }

      return data as UserProfile | null;
    } catch (error) {
      logger.error('Kullanıcı profil alma hatası:', error);
      return null; // Hata durumunda null döndür, throw etme
    }
  },

  // Telefon numarası ile kullanıcı ara
  getUserByPhone: async (phoneNumber: string): Promise<UserProfile | null> => {
    try {
      // Basic normalization
      const normalizedPhone = phoneNumber.replace(/\s+/g, '').replace(/^0/, '+90');

      const { data, error } = await supabase
        .from('user_profiles')
        .select('*')
        .eq('phone_number', normalizedPhone)
        .single();

      if (error) {
        if (error.code === 'PGRST116') return null;
        throw error;
      }

      return data as UserProfile;
    } catch (error) {
      logger.error('Telefon ile kullanıcı arama hatası:', error);
      throw error;
    }
  },

  // Kullanıcı profilini güncelle
  updateUserProfile: async (id: string, updates: Partial<UserProfile>): Promise<void> => {
    try {
      const { error } = await supabase
        .from('user_profiles')
        .update(updates)
        .eq('id', id);

      if (error) throw error;
    } catch (error) {
      logger.error('Kullanıcı profil güncelleme hatası:', error);
      throw error;
    }
  },

  // Son giriş zamanını güncelle (Opsiyonel / Ekstra)
  updateLastLogin: async (id: string): Promise<void> => {
    // Profilde last_login tutmuyorsanız bunu Supabase auth.users last_sign_in_at üzerinden alabilirsiniz.
    // Eğer user_profiles'da tutuyorsanız burayı aktif edebilirsiniz.
  },

  // Kullanıcıyı sil
  deleteUser: async (id: string): Promise<void> => {
    try {
      const { error } = await supabase
        .from('user_profiles')
        .delete()
        .eq('id', id);

      if (error) throw error;
    } catch (error) {
      logger.error('Kullanıcı silme hatası:', error);
      throw error;
    }
  }
};
